wbApp.controller('CzMsMtRegistryDetailCtrl', ['$scope', '$modal', 'czMsMtRegistrySvc', 'messageBoxSvc',
function ($scope, $modal, czMsMtRegistrySvc, messageBoxSvc) {

    $scope.modelOrig = angular.copy($scope.model);
    $scope.lastValidatedModel = angular.copy($scope.model);
    
    $scope.onStudentChange = function(studentId) {
        czMsMtRegistrySvc.changeStudentId($scope.model, studentId);
    }
    
    $scope.onActivityChange = function () {
        czMsMtRegistrySvc.changeActivityId($scope.model, $scope.model.activityId);
    }

    // Detect changes in activity name
    if ($scope.model.activityId) {
        $scope.onActivityChange();
    }

    $scope.onSaveAsANewRecord = function(data) {
        czMsMtRegistrySvc.validate(data).$promise.then(function(success) {
            if (success.length === 0) {
                detailSaveAsNewImpl(data);
            }
            else {
                messageBoxSvc.showMessageDlg({
                    title: 'TXT_TITLE_CONFIRMATION',
                    message: 'Záznam není validní! Opravdu chcete vytvořit novou větu k tomuto studentovi?',
                    buttons: [{
                        text: 'TXT_BTN_NO'
                    }, {
                        text: 'TXT_BTN_YES',
                        callback: function () {
                            detailSaveAsNewImpl(data);
                        }
                    }]
                });
            }
        });
    }
    
    $scope.onDetailSave = function (data) {
        if ($scope.modelOrig.isValid) {
            // Record was valid before, let's try to validate it again 
            let dataCopy = angular.copy(data);
            czMsMtRegistrySvc.validate(dataCopy).$promise.then(function(success) {
                if (success.length === 0) {
                    detailSaveImpl(data);
                } else {
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_CONFIRMATION',
                        message: 'Záznam není validní! Před Vaší poslední úpravou byl záznam validní. Opravdu chcete tuto změnu uložit?',
                        buttons: [{
                            text: 'TXT_BTN_NO'
                        }, {
                            text: 'TXT_BTN_YES',
                            callback: function () {
                                detailSaveImpl(data);
                            }
                        }]
                    });
                }
            });
        } else {
            detailSaveImpl(data);
        }
    }
    
    function detailSaveAsNewImpl(data) {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        let dataCopy = angular.copy(data);
        dataCopy.id = null;
        
        czMsMtRegistrySvc.insert(dataCopy)
            .$promise.then(success, error);

        function success(newModel) {
            $scope.onRegistryDetailSave(newModel);
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }        
    }
    
    function detailSaveImpl(data) {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;
        let dataCopy = angular.copy(data);
        
        if (!data.id) {
            czMsMtRegistrySvc.insert(dataCopy)
                .$promise.then(success, error);
        } else {
            czMsMtRegistrySvc.update(dataCopy)
                .$promise.then(success, error);
        }

        function success(newModel) {
            $scope.onRegistryDetailSave(newModel);
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }
    
    $scope.onValidate = function (data) {
        if ($scope.isValidating) {
            return;
        }
        
        $scope.isValidating = true;
        let dataCopy = angular.copy(data);
        
        czMsMtRegistrySvc.validate(dataCopy).$promise.then(function(success) {
            $scope.isValidating = false;
           if (success.length === 0) {
               data.isValid = true;
               $scope.lastValidatedModel = angular.copy(data);
           } else {
               data.isValid = false;
               $scope.lastValidatedModel = angular.copy(data);

               let message = '';
               _.forEach(success, function (s) {
                   message += '<div><i class="fa fa-lg fa-exclamation-circle text-danger" aria-hidden="true"></i> ' + s + ' </div>';
               });
               messageBoxSvc.showMessageDlg({
                   title: 'TXT_TITLE_INFORMATION',
                   message: message,
                   buttons: [{
                       text: 'TXT_BTN_OK'
                   }]
               });
           }
        }, function(error) {
            $scope.isValidating = false;
            alert(error);
        });
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };


    $scope.isFormValid = function(data) {
        return angular.equals(data, $scope.lastValidatedModel) && $scope.lastValidatedModel.isValid;
    }
    
    $scope.requireSpecialEducationChanged = function(requireSpecialEducation) {
        czMsMtRegistrySvc.setRequireSpecialEducation($scope.model, requireSpecialEducation);
    }
    
    $scope.detailTabs = [{
        title: 'TXT_MAIN',
        template: "cz-ms-mt-registry/cz-ms-mt-registry-detail-main-tab.html"
    },{
        title: 'TXT_LBL_ATTENDANCE',
        template: "cz-ms-mt-registry/cz-ms-mt-registry-detail-attendance-tab.html"
    },{
        title: 'Platnost věty',
        template: "cz-ms-mt-registry/cz-ms-mt-registry-detail-changes-tab.html"
    },{
        title: 'Speciální potřeby',
        template: "cz-ms-mt-registry/cz-ms-mt-registry-detail-special-tab.html"
    }];

    $scope.detailTabs.activeTab = 0;
    
    $scope.validFromUtc_help = "<p class=\"help-block\">\"Začátek platnosti věty\" se uvádí datum, od kterého platí kombinace hodnot položek uvedená v datové větě. U téhož\n" +
        "        žáka/studenta musí jednotlivé předávané věty na sebe přesně časově navazovat. Se začátkem platnosti nové věty\n" +
        "        s aktualizovaným obsahem položek se zároveň ukončuje platnost předchozí věty, a to dnem předcházejícím. Položka\n" +
        "        \"Začátek platnosti věty\" musí být vyplněna u každé věty</p>\n" +
        "    <p class=\"help-block\">U žáků/studentů se vytváří nová věta vždy minimálně k 1. 9., kdy žáci postupují do vyšších ročníků, mění se název\n" +
        "        třídy, příp. opakují ročník. U individuálního vzdělávacího plánu, který stanovuje organizaci vzdělávání odlišně\n" +
        "        od standardního období školního roku, se rovněž vždy k 1. 9. vytváří nová věta.</p>"
    
    $scope.kodVety_help = "Kód věty (podle číselníku RAKV) rozlišuje, za koho se příslušná věta předává, a umožňuje kontrolovat správnost\n" +
        "vyplnění ostatních položek. Jiné vyplnění položek je požadováno ve větě o žákovi/studentovi, jiné ve větě\n" +
        "o absolventovi, o osobě s přerušeným vzděláváním nebo ukončeným vzděláváním bez absolvování (předepsaná\n" +
        "zkouška nesložena), apod.";
    
    $scope.zmendat_help = "\n" +
        "<p class=\"help-block\">\n" +
        "    Za každého žáka se předává tolik vět, kolikrát se změnil obsah předávaných údajů za vykazované období (nezahrnuje\n" +
        "    opravy chybně zadaných údajů!!!). Předávají se vždy <b>úplné</b> věty, obsahující všechny povinné položky, přičemž tyto\n" +
        "    věty na sebe časově plynule navazují.\n" +
        "</p>" +
        "<p class=\"help-block\">\n" +
        "    Položka KOD_ZMEN v sobě obsahuje informaci o registrované změně, jež je už promítnuta v položkách této aktuální\n" +
        "    věty. Kód změny uvedený podle číselníku RAKZ se tedy objevuje ve větě s „novými“ údaji. Pokud došlo k několika\n" +
        "    změnám ve stejném termínu, uvádí se kód odpovídající hlavnímu důvodu vzniku nové věty\". Zjednodušeně by se dalo\n" +
        "    říci, že \"vyšší\" hodnota kódu má přednost před \"nižší\" (výjimkou je kód 8). Nejvyšší prioritu však má KOD_ZMEN=7\n" +
        "    změna osobního identifikátoru – v takovém případě se v komentáři uvede doposud uváděný identifikátor.\n" +
        "    Standardní postoupení do vyššího ročníku sice vytváří vždy novou větu, ale tato očekávaná změna se nepromítá\n" +
        "    do změnových položek.\n" +
        "</p>";
    
    $scope.validToUtc_help = "<p class=\"help-block\">\n" +
        "    V položce PLAT_KON se uvádí datum, do kterého platila kombinace hodnot položek uvedená v datové větě.\n" +
        "</p>\n" +
        "<p class=\"help-block\">\n" +
        "    V <b>aktuálně platné větě zůstává položka PLAT_KON prázdná</b>, neboť konec platnosti této věty ještě nenastal.\n" +
        "    Jinými slovy u vět, které jsou aktuální a tudíž platné, je položka PLAT_KON nevyplněna, neuvádí se předpokládané\n" +
        "    budoucí datum ukončení platnosti věty.\n" +
        "</p>";
    
    $scope.zahdat_help = "<p class=\"help-block\">\n" +
        "    Zahájení školního vzdělávání se vztahuje k aktuální škole, případně druhu studia (přechod do nástavbového nebo\\n\" +\n" +
        "    \"zkráceného studia pro získání středního vzdělání). Pokud žák přestupuje z jiné školy podle §§ 45, 66 nebo 97\\n\" +\n" +
        "    \"školského zákona, uvede se kód pro přestup z jiné školy.\n" +
        "</p>";
    
    $scope.izo_help = "<p class=\"help-block\">\n" +
        "    <b>Resortní identifikátor školy (IZO)</b>, se objevuje v názvu souboru, v záhlaví souboru a v každé větě souboru v položce\n" +
        "    IZO. V názvu souboru i uvnitř souboru musí být ve všech větách uvedeno stejné IZO.\n" +
        "    Je třeba rozlišovat resortní identifikátor <b>právnické osoby</b> vykonávající činnost školy (RED_IZO), uváděný od roku\n" +
        "    2011 na vysvědčeních o maturitní zkoušce, a resortní identifikátor <b>školy</b> (IZO), který se uvádí na dalších dokladech\n" +
        "    o vzdělání (vyhláška č. 3/2015 Sb. o některých dokladech o vzdělání, ve znění pozdějších předpisů).\n" +
        "</p>";
    
    $scope.cast_help = "<p class=\"help-block\">\n" +
        "    <b>Číslo části</b> je uvedeno (podobně jako IZO) v názvu souboru, v záhlaví souboru a v každé větě za každou vykazovanou\n" +
        "    osobu v položce CAST a v souboru za jednu část musí být všude stejné. Jde o rozlišení jednotlivých míst\n" +
        "    poskytovaného vzdělávání v rámci jednoho druhu školy (jednoho platného IZO) pomocí znaků 01, 02, atd.\n" +
        "</p>\n" +
        "<p class=\"help-block\">\n" +
        "    Číslo části v předávaných souborech musí odpovídat stavu v nabídce <b>„Nastavení částí“</b> v aplikaci pro předání dat ze\n" +
        "    školních matrik. Čísla částí u jednotlivých míst by měla škola <b>zkontrolovat</b> a podle potřeby upravit <b>před každým\n" +
        "    novým sběrem dat</b> tak, aby odpovídala počtu předávaných souborů a jejich označení.\n" +
        "</p>";
    
    
}]);
